
import Vue from "vue";
import { Dossier } from "@/models/dossier";
export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>Dossier,
			required: true
		}
	}
});
